<div class="row">
  <div class="col-md-3">
    <div class="d-grid gap-2">
      <button [disabled]="disabled" class="btn btn-secondary" (click)="add();openModal(modal, modalIdx)">
        <fa-icon [icon]="faPlus" [fixedWidth]="true"></fa-icon>Add WX Phenomena
      </button>
    </div>
  </div>
  <div class="col-md-9">
    <div *ngFor="let phenomena of wxPhenomena; let idx = index">
      <nlf-ors-editor-tag-e5x-render classes="badge bg-danger" [items]="phenomena.attributes.phenomenonType.value" path="E5X.Occurrence.PrecipitationAndOtherWeatherPhenomena.PhenomenonType"></nlf-ors-editor-tag-e5x-render>
      &nbsp;
      <nlf-ors-editor-tag-e5x-render classes="badge bg-danger" [items]="phenomena.attributes.phenomenonIntensity.value" path="E5X.Occurrence.PrecipitationAndOtherWeatherPhenomena.PhenomenonIntensity"></nlf-ors-editor-tag-e5x-render>
      <fa-icon class="mx-1" [icon]="faEdit" (click)="openModal(modal, idx)"></fa-icon>
      <fa-icon class="mx-1" *ngIf="!disabled" [icon]="faClose" (click)="delete(idx)"></fa-icon>
    </div>

  </div>
</div>

<!-- ROUTE MODAL -->
<ng-template #modal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      Wx Phenomena {{ wxPhenomena.length }}
    </h4>
    <button type="button" class="close float-end" aria-label="Close" (click)="modalRef.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="row">


      <div class="col-md-12">
        <nlf-ors-editor-tag-e5x [disabled]="disabled" [(items)]="modalValue.attributes.phenomenonType.value" path="E5X.Occurrence.PrecipitationAndOtherWeatherPhenomena.PhenomenonType"
          id="phenomenonType"></nlf-ors-editor-tag-e5x>
      </div>
      <div class="col-md-12">
        <nlf-ors-editor-tag-e5x [disabled]="disabled" [(items)]="modalValue.attributes.phenomenonIntensity.value" path="E5X.Occurrence.PrecipitationAndOtherWeatherPhenomena.PhenomenonIntensity"
          id="phenomenonIntensity"></nlf-ors-editor-tag-e5x>
      </div>
    </div>

  </div>


  <div class="modal-footer">
    <button class="btn btn-outline-dark" (click)="modalRef.close()">
      <fa-icon [icon]="faTimes" [fixedWidth]="true"></fa-icon>Avbryt
    </button>
    <button [disabled]="disabled" [ngClass]="{'disabled': disabled}" class="btn btn-success" (click)="modalUpdate()">
      <fa-icon [icon]="faCheck" [fixedWidth]="true"></fa-icon>Oppdater
    </button>
  </div>
</ng-template>
